import React from "react";
import { Modal } from "@/components/Modal";
import { Button } from "@/components/common/Button";

import styles from "./VoiceModaDisabledModal.module.css";

type Props = {
  isOpen?: boolean;
  onClose: () => void;
};

export const VoiceModaDisabledModal: React.FC<Props> = ({
  isOpen = false,
  onClose,
}) => {
  return (
    <Modal className={styles.modal} isOpen={isOpen} onClose={onClose}>
      <div className={styles.text}>
        Le mode vocal n'est pas disponible dans la version préliminaire.
      </div>
      <Button
        variant="clean"
        onClick={() => {
          onClose();
        }}
        className={styles.button}
      >
        Compris !
      </Button>
    </Modal>
  );
};
